/**
 * ReponsavelAssociadoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ReponsavelAssociado} from '@/model/resource/ReponsavelAssociado'

/* TODO: review generated class */
@HttpExclude()
export class ReponsavelAssociadoCollection extends PageCollection<
  ReponsavelAssociado
> {
  constructor() {
    super(ReponsavelAssociado)
  }

  queryAsPage() {
    return this.listReponsavelAssociado()
  }

  async listReponsavelAssociado() {
    return await Request.get(`/admin/reponsavel-associado`, {
      params: this.params,
    })
      .name('listReponsavelAssociado')
      .as(this)
      .getResponse()
  }

  async listCsvReponsavelAssociado() {
    return await Request.get(`/admin/reponsavel-associado/csv`, {
      params: this.params,
    })
      .name('listCsvReponsavelAssociado')
      .as(this)
      .getResponse()
  }
}
